import React from 'react'
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Text,
	Link,
	VStack,
	useColorModeValue,
} from '@chakra-ui/react'

export default function BGModal(props) {
	const bodyColor = useColorModeValue('gray.600', 'bgg.muted')
	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} motionPreset="none" size="md">
			<ModalOverlay bg="blackAlpha.600" />
			<ModalContent rounded="xl" mx={4}>
				<ModalHeader>About</ModalHeader>
				<ModalCloseButton rounded="lg" />
				<ModalBody pb={6}>
					<VStack align="stretch" spacing={3} fontSize="sm" color={bodyColor}>
						<Text>
							<strong>Author:</strong> Alfredo Medina
						</Text>
						<Text>
							<strong>Contact:</strong> info@amedpal.com
						</Text>
						<Link href="https://github.com/alfremedpal/board-game-picker" isExternal color="brand.600" fontWeight="500">
							GitHub repository
						</Link>
						<Link href="https://www.buymeacoffee.com/amedpal" isExternal color="brand.600" fontWeight="500">
							Buy me a coffee
						</Link>
					</VStack>
				</ModalBody>
			</ModalContent>
		</Modal>
	)
}
